import React from 'react';
import { useRecoilState } from 'recoil';
import * as AppState from '../../../../AppState';
import MinMaxInputs from '../../../Shared/MinMaxInputs/MinMaxInputs';

const SquareFootageRange = (props: { minLabel?: string, maxLabel?: string, wrapperClass?: string }) => {
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	const [minValue, setMinValue] = React.useState<string>(gsFilters.yearBuiltMin === 0 ? '' : gsFilters.yearBuiltMin.toString());
	const [maxValue, setMaxValue] = React.useState<string>(gsFilters.yearBuiltMax === -1 ? '' : gsFilters.yearBuiltMax.toString());

	// Handles filter reset
	React.useEffect(() => {
		setMinValue(gsFilters.yearBuiltMin === 0 ? '' : gsFilters.yearBuiltMin.toString());
		setMaxValue(gsFilters.yearBuiltMax === -1 ? '' : gsFilters.yearBuiltMax.toString());
	}, [gsFilters]);

	return (
		<MinMaxInputs
			id="yearBuiltFilter"
			wrapperClass={props.wrapperClass ? props.wrapperClass : 'w-100'}
			minValue={minValue}
			maxValue={maxValue}
			globalMinValue={gsFilters.yearBuiltMin}
			globalMaxValue={gsFilters.yearBuiltMax}
			minPossibleValue={1800}
			maxPossibleValue={new Date().getFullYear()}
			label='Year Built'
			minLabel=''
			maxLabel=''
			setMinValue={setMinValue}
			setMaxValue={setMaxValue}
			callback={([min, max]) => setGsFilters(currVal => ({
				...currVal,
				yearBuiltMin: min,
				yearBuiltMax: max
			}))}
		/>
	);
};

export default SquareFootageRange;
